import React, { useEffect, useState, useContext } from "react";
import { isMobile } from "react-device-detect";
import useTranslation from "../../hooks/useTranslation";

const NSMultiSelector = ({
  options: optionsProps,
  oneSelection,
  onCallBack,
  initial,
  className,
  customInitial,
  customColorActive,
  customColor,
  criticalItems,
}) => {
  const T = useTranslation();
  const [current, setCurrent] = useState([]);
  const [options, setOptions] = useState(optionsProps || []);
  const [selectedOptions, setSelectedOptions] = useState(initial || []);

  const checkBoxType = oneSelection ? "radio" : "checkbox";

  const handlerOnClick = (e) => {
    const element = e.target.value;
    const have = exist(element);

    if (oneSelection) {
      setSelectedOptions((prev) => (prev[0] == element ? [] : [element]));
    } else {
      setSelectedOptions((prev) =>
        prev.filter((i) => i == element).length > 0
          ? [...prev.filter((i) => i != element)]
          : [...prev, element]
      );
    }
  };

  const exist = (item) => {
    if (typeof selectedOptions != Array) return false;
    if (selectedOptions?.find((a) => a === item)) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    if (onCallBack) {
      console.log("hay un calback" + selectedOptions);
      setCurrent(selectedOptions);
      onCallBack(oneSelection ? selectedOptions[0] : selectedOptions);
    }
  }, [selectedOptions]);

  return (
    <div
      className={`w-full text-xl overflow-auto flex flex-col gap-2 ${
        className || ""
      }`}
    >
      {options?.map((item, index) => {
        const isCurrent = oneSelection
          ? current[0] == item
          : current.filter((i) => i == item).length > 0;
        const isCritical = criticalItems?.includes(index);

        const key = `opt-${index}-${item}`;
        return (
          <label
            htmlFor={key}
            style={
              isCritical
                ? {
                    background: isCurrent
                      ? isCritical
                        ? "#F9839A"
                        : "#2AAC9C"
                      : isCritical
                      ? "#FEEFF2"
                      : "#EAF7F5",
                    color: isCurrent ? "white" : "black",
                    color: isCurrent ? "white" : "black",
                    borderRadius: "7px",
                  }
                : {
                    background: isCurrent
                      ? index < parseInt(customInitial)
                        ? customColorActive
                          ? customColorActive
                          : "#2aac9c"
                        : "#2aac9c"
                      : index < parseInt(customInitial)
                      ? customColor
                        ? customColor
                        : "#eaf7f5"
                      : "#eaf7f5",
                    color: isCurrent ? "white" : "black",
                    borderRadius: "7px",
                  }
            }
            className="flex gap-4 py-3 w-full p-3 min-h-[60px] text-lg items-center cursor-pointer"
            key={key}
          >
            <input
              type={checkBoxType}
              style={{
                fontSize: isMobile ? "14px" : "22px",
                accentColor: isCurrent ? "#000" : "#2aac9c",
              }}
              className="h-[30px] w-[30px] accent-[#fff] checked:bg-[red]"
              id={key}
              value={item}
              checked={isCurrent}
              onChange={handlerOnClick}
            />
            <span style={styles.label}>{T(item)}</span>
          </label>
        );
      })}
    </div>
  );
};

export default NSMultiSelector;

const styles = {
  label: {
    fontSize: isMobile ? "14px" : "18px",
    lineHeight: isMobile ? "18px" : "22px",
    cursor: "pointer",
    width: "100%",
  },
};
